import { CheckCircleIcon } from "@heroicons/react/24/outline";
import { Illustration } from "ts/interfaces/common/illustration";
import { renderDate } from "utils/helpers";

interface IllustrationsProps {
  illustrations: Illustration[];
}

const Illustrations: React.FC<IllustrationsProps> = ({ illustrations }) => {
  return (
    <div className="overflow-hidden rounded-lg shadow ring-1 ring-black ring-opacity-5">
      <table className="min-w-full divide-y divide-gray-300 bg-white">
        <thead className="bg-gray-50">
          <tr>
            <th
              scope="col"
              className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
            >
              Reference
            </th>
            <th
              scope="col"
              className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
            >
              Date created
            </th>
            <th
              scope="col"
              className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
            >
              Product
            </th>
            <th
              scope="col"
              className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
            >
              Application
            </th>
            <th
              scope="col"
              className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
            >
              <span className="sr-only">Action</span>
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-200 bg-white">
          {illustrations.length ? (
            illustrations.map((ill, i) => (
              <tr key={i}>
                <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                  {ill.reference}
                </td>
                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-600">
                  {renderDate(ill.createdOn)}
                </td>
                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-600">
                  {ill.productReference}
                </td>
                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-600">
                  {ill.createdBySubmission && (
                    <CheckCircleIcon className="inline h-6 w-6 self-center text-green-800" />
                  )}
                </td>
                <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                  <a
                    download
                    href={ill?.downloadUrl}
                    className="link underline"
                  >
                    Download
                  </a>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td
                colSpan={4}
                className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6"
              >
                -
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default Illustrations;
